<template>
  <div>
    <div class="search-box">
      <div class="input-item">
        <span class="label">保单编号</span>
        <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">IFA</span>
        <Select v-model="searchParams.owerId" clearable filterable>
          <Option v-for="item in ifaList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">结算状态</span>
        <Select v-model="searchParams.settlementStatus" clearable>
          <Option value="0">待结算</Option>
          <Option value="1">已结算</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">对账状态</span>
        <Select v-model="searchParams.checkStatus" clearable>
          <Option value="1">待确认</Option>
          <Option value="2">已确认待打款</Option>
          <Option value="3">打款成功</Option>
        </Select>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">查询</Button>
        <Button type="primary" ghost @click="resetSearch()">重置</Button>
        <Button type="primary" @click="handleAdd">新增</Button>
        <Button type="primary" ghost @click="handleExport">导出</Button>
      </div>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="surroundingColumns" :data="tableData"> </Table>
      <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" :page-size-opts="[10, 20, 30, 50, 100]" style="text-align: center" />
    </div>
    <surroundingModal ref="modalRef" :ifaList="ifaList" @success="getList" />
  </div>
</template>

<script>
import surroundingModal from './surroundingModal';
import { pageTool, common } from '@/api/mixins';
import { config } from '../index.config.js';

const LIST_URL = '/buz/ifaExtraCommissionLog/read/list';
const DELETE_URL = '/buz/ifaExtraCommissionLog/del';

const DEFAULT_SEARCH_PARAMS = {
  commissionType: '1',
  policyNo: '',
  owerId: '',
  settlementStatus: '',
  checkStatus: ''
};

export default {
  name: 'SurroundingTab',
  mixins: [pageTool, common, config],
  components: { surroundingModal },
  props: {
    ifaList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchParams: { ...DEFAULT_SEARCH_PARAMS }
    };
  },
  activated() {
    this.getList();
  },
  mounted() {
    this.getColumns();
    this.initListParams(LIST_URL);
  },
  methods: {
    handleExport() {
      let params = JSON.parse(JSON.stringify(this.searchParams));
      this.$units.downloadFile('/buz/ifaExtraCommissionLog/export', params, 'POST');
    },
    handleAdd() {
      this.$refs.modalRef.open();
    },
    handleEdit(row) {
      this.$refs.modalRef.open(row);
    },
    handleDelete(row) {
      this.$Modal.confirm({
        title: '确认删除',
        content: '确定要删除该条周边收支记录吗？',
        onOk: () => {
          this.$http({
            type: 'GET',
            url: DELETE_URL,
            data: { id: row.id }
          }).then(() => {
            this.$notice.msg('删除成功');
            this.getList();
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.search-box {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  padding-right: 380px;
  .input-item {
    display: flex;
    align-items: center;
    width: 25%;
    margin-bottom: 16px;
    padding-right: 20px;
    .label {
      white-space: nowrap;
      margin-right: 8px;
    }
    > div,
    /deep/ .ivu-input-wrapper,
    /deep/ .ivu-select,
    /deep/ .ivu-date-picker {
      flex: 1;
    }
  }
  .btn-item {
    display: flex;
    align-items: center;
    button {
      margin-right: 8px;
    }
  }
}
</style>
